import { useState } from 'react';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text12 from '@sdk/components/ui/typography/Text12';

import { Article, ArticleComment as Comment } from '@web/newsfeed/types/Article';
import {
  Container,
  LoadMoreButton,
} from '@web/newsfeed/Article/ArticleComments/articleComments.styles';
import { useArticleComments } from '@web/newsfeed/Article/ArticleComments/articleComments.hooks';
import { ArticleComment } from '@web/newsfeed/Article/ArticleComments/ArticleComment/ArticleComment';
import { LikedByModal } from '@web/newsfeed/LikedBy/likedByModal';
import { ArticleCommentEditor } from '@web/newsfeed/Article/ArticleComments/ArticleCommentEditor/ArticleCommentEditor';
import { ArticleCommentsSkeleton } from '@web/newsfeed/Article/ArticleComments/ArticleCommentsSkeleton/ArticleCommentsSkeleton';

export type Props = {
  article: Article;
};

export const ArticleComments = ({ article }: Props) => {
  const [selectedComment, setSelectedComment] = useState<Comment | null>(null);
  const isCommentLikesModalOpen = !!selectedComment;
  const { comments, isLoadingResults, hasPreviousPage, fetchPreviousPage, loadersCount } =
    useArticleComments({
      article,
    });

  return (
    <Container>
      {!!loadersCount && <ArticleCommentsSkeleton placeholdersCount={loadersCount} />}

      {!isLoadingResults && hasPreviousPage && (
        <LoadMoreButton onClick={() => fetchPreviousPage()}>
          <Text12 themeColor={ThemeColorType.primary} bold>
            {gettext('Load older comments')}
          </Text12>
        </LoadMoreButton>
      )}

      {!!comments?.length &&
        comments.map((comment) => (
          <ArticleComment
            key={comment.id}
            comment={comment}
            onLikeCounterClick={() => setSelectedComment(comment)}
          />
        ))}

      <ArticleCommentEditor articleId={article.id} pageId={article.page.id} />

      {!!isCommentLikesModalOpen && (
        <LikedByModal
          isVisible={!!isCommentLikesModalOpen}
          onClose={() => setSelectedComment(null)}
          pageId={article.page.id}
          articleId={article.id}
          commentId={selectedComment.id}
          likedByCount={selectedComment.likesCount}
        />
      )}
    </Container>
  );
};
